import { useCallback, useState } from "react";

export function useDisclose(initState = false) {
  const [isOpen, setIsOpen] = useState(initState || false);

  const onOpen = useCallback(() => setIsOpen(true), []);

  const onClose = useCallback(() => setIsOpen(false), []);

  const onToggle = useCallback(() => setIsOpen((_isOpen) => !_isOpen), []);

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
  };
}
